import React from "react";

interface SitchLogoProps {
  className?: string;
}

const SitchLogo: React.FC<SitchLogoProps> = ({ className = "" }) => (
  <div className={`text-center ${className}`}>
    <h1 className="text-3xl text-white tracking-wide font-nostalgic">SITCH</h1>
  </div>
);

SitchLogo.defaultProps = {
  className: "",
};

export default SitchLogo;
